import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';
@Directive({
  selector: '[errorInput]',
})
export class ErrorInputDirective implements OnInit {
  @Input() errorStatus: boolean;
  constructor(private elmRef: ElementRef, private renderer: Renderer2) {}
  ngOnInit() {
    if (this.errorStatus) {
      this.renderer.setStyle(this.elmRef.nativeElement, 'color', 'red');
      this.renderer.setStyle(
        this.elmRef.nativeElement,
        'border',
        '1px solid red'
      );
    }
  }
}
